// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2898": "67f61860","5336": "5083bc52","544": "745e4b29",}[chunkId] + ".css"
}